import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getIssueSeverity } from 'pages/Desk/issues/shared';
import { memo } from 'react';
import { Lozenge } from 'shared/lozenge/Lozenge';
import { KCFColor } from 'styles/themes/KCFColor';

type SeverityLozengeProps = Readonly<{
    severity: number;
}>;

function SeverityLozenge({ severity }: SeverityLozengeProps) {
    const { label, icon, backgroundColor } = getIssueSeverity(severity);
    const upperLabel = label.toUpperCase();

    return (
        <Lozenge color={KCFColor.white} backgroundColor={backgroundColor}>
            <FontAwesomeIcon icon={icon} />
            {upperLabel}
        </Lozenge>
    );
}

const memoSeverityLozenge = memo(SeverityLozenge);
export { memoSeverityLozenge as SeverityLozenge };
